import React from 'react';
import {Layout} from '../../../widgets/Layout';
import { Link } from 'react-router-dom';
import icons from '../../../shared/lib/icons';
import {commonStyles, theme} from '../../../shared/lib/styles';

const StatCard = ({ title, value, icon, to }) => (
    <Link to={to} style={styles.statCardLink}>
        <div style={styles.statCard}>
            <div style={styles.icon}>{icon}</div>
            <div>
                <div style={styles.statValue}>{value}</div>
                <div style={styles.statTitle}>{title}</div>
            </div>
        </div>
    </Link>
);

const ActionButton = ({ label, color, to }) => (
    <Link to={to} style={{ ...styles.actionButton, backgroundColor: color }}>
        {label}
    </Link>
);

const Dashboard = () => {
    return (
        <Layout>
            <div style={styles.statsGrid}>
                <StatCard
                    title="Аудиопособие"
                    value="Аудиопособие"
                    icon={icons.audio}
                    to="/audioposobie"
                />
                <StatCard
                    title="Интерактив"
                    value="Викторины"
                    icon={icons.quiz}
                    to="/quizzes"
                />
            </div>
            <section style={styles.section}>
                <div style={styles.quickActions}>
                    <ActionButton label="Мои плейлисты" color={theme.colors.brandTeal} to="/playlists" />
                </div>
            </section>
        </Layout>
    );
};

const styles = {
    statsGrid: {
        ...commonStyles.grid,
        marginBottom: theme.spacing.xxl,
    },
    statCardLink: commonStyles.statCardLink,
    statCard: {
        ...commonStyles.statCard,
        padding: theme.spacing.lg,
    },
    icon: {
        fontSize: theme.fontSize['4xl'],
    },
    statValue: {
        fontSize: theme.fontSize['3xl'],
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.textPrimary,
    },
    statTitle: {
        fontSize: theme.fontSize.sm,
        color: theme.colors.textSecondary,
        marginTop: theme.spacing.xs,
    },
    section: commonStyles.section,
    sectionTitle: commonStyles.sectionTitle,
    quickActions: commonStyles.flexRow,
    actionButton: {
        ...commonStyles.button,
        padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
        borderRadius: theme.borderRadius.xl,
        color: 'white',
        textDecoration: 'none',
        boxShadow: theme.shadows.md,
    },
};

export default Dashboard;

